import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalEditUserAdmin",
  tabindex: "-1",
  "aria-labelledby": "modalEditUserAdmin",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "createMessageTemplateSuccess"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "my-3 text-center" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  serverError: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CC40title')), 1),
          _hoisted_6
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)(__props.serverError ? 'CC40updateFailed' : 'updateComplete')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})